import type { Permission } from '@thrivehrm/shared';

/**
 * Who may have requests to decide in `/approvals` (the inbox is also open to everyone with
 * reports, who decide their team's leave and WFH): HR for Bank & TIN and for leave / WFH of
 * people without a manager, payroll approvers for runs.
 */
export const APPROVER_PERMISSIONS: readonly Permission[] = [
  'bank.approve',
  'leave.manage',
  'attendance.manage',
  'payroll.approve',
];
